import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getDistribution = async (applicationHistoryId) => {
	const { data } = await axios.get(`${API_GO}/app/history/io/${applicationHistoryId}/distribution`);
	return data;
};

export const saveDistribution = async (applicationHistoryId, businessCenters, listType = null, filters = null) => {
	const payload = {
		business_centers: businessCenters,
	};

	if (listType && filters) {
		payload.list_type = listType;
		payload.filters = filters;
	}

	const { data } = await axios.put(`${API_GO}/app/balance/io/${applicationHistoryId}/distribution`, payload);
	return data;
};
